// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__QTiXs","container":"Dialog_container__nBXKC","content":"Dialog_content__TGUmp"};